module.exports = __webpack_public_path__ + "static/media/carta_2.f6e702a9.jpg";